(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/stream-player/assets/javascripts/stream-player.js') >= 0) return;  svs.modules.push('/components/racing/stream-player/assets/javascripts/stream-player.js');

'use strict';

const useState = React.useState;
const useEffect = React.useEffect;
const DropDownHeader = svs.racing.streamplayer.DropDownHeader;
const StreamPlayerError = svs.racing.streamplayer.StreamPlayerError;
const StreamPlayerPreloader = svs.racing.streamplayer.StreamPlayerPreloader;
const VideoEndedButtons = svs.racing.streamplayer.VideoEndedButtons;
let empComponentLoaded;
const {
  useContext
} = React;
const {
  VODContext
} = svs.racing;
const StreamPlayer = _ref => {
  let {
    isStartPage,
    showLive
  } = _ref;
  const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  const [playerIsVisible, setPlayerIsVisible] = useState(!svs.core.detect.formfactor.mobile());
  const [sessionToken, setSessionToken] = useState(undefined);
  const [assetId, setAssetId] = useState(svs.components.Storage.browser.get('storedAssetId', 'StreamPlayer'));
  const [thumbnail, setThumbnail] = useState(undefined);
  const [hasError, setHasError] = useState(false);
  const [nrOfReloads, setNrOfReloads] = useState(0);
  const getPlayList = svs.racing.streamplayer.StreamPlayerDataHandler.getPlayList;
  const getSessionToken = svs.racing.streamplayer.StreamPlayerDataHandler.getSessionToken;
  const autoplay = true;
  const [showPreloadImage, setShowPreloadImage] = useState(true);
  const [playerIsLoaded, setPlayerIsLoaded] = useState(false);
  const useLowLatency = svs.core.detect.browser.safari() ? false : 'MediaSource' in window && MediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E, mp4a.40.2"');
  const [liveStreamLoaded, setLiveStreamLoaded] = useState(svs.components.Storage.browser.get('liveStreamLoaded', 'StreamPlayer'));
  const [folded, setFolded] = useState(true);
  const [videoEnded, setVideoEnded] = useState(false);
  const [replay, setReplay] = useState(false);
  const [noRaceDataState, setNoRaceDataState] = useState(false);
  const [replayKey, setReplayKey] = useState(1);
  const businessunit = svs.utils.ns.isNamespace('svs.racing.streamplayer.data.businessunit') ? svs.racing.streamplayer.data.businessunit : 'RacingOnline';
  const {
    currentVOD,
    setCurrentVOD
  } = useContext(VODContext);
  const loadEmpComponent = callback => {
    if (!empComponentLoaded) {
      svs.core.module.load('/cl/components/react:redbeemedia', null, () => {
        empComponentLoaded = true;
        callback();
      });
    }
  };
  const getLaunchParameters = () => {
    if (!empComponentLoaded) {
      loadEmpComponent(getLaunchParameters);
    }
    const options = {
      businessunit
    };
    setShowPreloadImage(false);
    setPlayerIsLoaded(true);
    getSessionToken(options, data => {
      if (data) {
        setHasError(data.hasError);
        if (!data.hasError) {
          setSessionToken(data.sessionToken);
        }
      }
    });
  };
  const handleVideoEndedBtnClick = showStream => {
    setVideoEnded(false);
    if (showStream) {
      setCurrentVOD(undefined);
      getLaunchParameters();
    } else {
      setReplay(true);
      setTimeout(() => setReplay(false), 200);
    }
  };
  const handleVideoEnded = () => {
    setVideoEnded(true);
  };
  const handleVideoStarted = () => {
    const optLabel = currentVOD ? 'Vod' : 'Stream';
    svs.components.analytics.trackEvent({
      action: 'Start',
      category: 'Video',
      opt_label: optLabel
    });
  };
  const handleDropDownAction = isVisible => {
    setPlayerIsVisible(isVisible);
    setShowPreloadImage(false);
    setLiveStreamLoaded(true);
    setFolded(false);
    if (!playerIsLoaded && isLoggedIn) {
      getLaunchParameters();
    }
    if (!isLoggedIn) {
      let currentAssetId = assetId;
      if (currentVOD) {
        currentAssetId = currentVOD.assetId;
        svs.components.Storage.browser.set('storedVOD', 'VODService', currentVOD);
      } else {
        svs.components.Storage.browser.set('liveStreamLoaded', 'StreamPlayer', true);
      }
      svs.components.Storage.browser.set('storedAssetId', 'StreamPlayer', currentAssetId);
      svs.components.customer_login.login();
    }
  };
  useEffect(() => {
    if (showLive) {
      if (isLoggedIn) {
        getLaunchParameters();
      } else if (assetId) {
        handleDropDownAction(true);
      }
    }
  }, [showLive, assetId]);
  useEffect(() => {
    if (isLoggedIn && assetId) {
      setPlayerIsVisible(true);
      getLaunchParameters();
    } else if (!isLoggedIn) {
      setCurrentVOD(undefined);
    }
    svs.components.Storage.browser.remove('storedAssetId', 'StreamPlayer');
    svs.components.Storage.browser.remove('storedVOD', 'VODService');
    svs.components.Storage.browser.remove('liveStreamLoaded', 'StreamPlayer');
  }, []);
  useEffect(() => {
    const options = {
      businessunit,
      useLowLatency
    };
    getPlayList(options, data => {
      if (data) {
        setHasError(data.hasError);
        if (!data.hasError) {
          setHasError(data.hasError);
          setThumbnail(data.thumbnailSrc);

          if (!currentVOD) {
            setAssetId(data.assetId);
          }
        }
      }
    });
  });
  useEffect(() => {
    if (currentVOD && currentVOD.assetId !== assetId) {
      setAssetId(currentVOD.assetId);
      setPlayerIsVisible(true);
      if (isLoggedIn) {
        getLaunchParameters();
      } else {
        handleDropDownAction();
      }
    }
  }, [currentVOD]);
  const reload = () => {
    if (nrOfReloads === 0) {
      setNrOfReloads(1);
    }
  };
  const getHeaderInfo = () => {
    if (currentVOD) {
      const {
        date,
        track,
        raceNumber
      } = currentVOD;
      return "".concat(date, ", ").concat(track, ", ").concat(raceNumber ? "Lopp ".concat(raceNumber) : '');
    }
    return '';
  };
  const bumpReplayKey = () => {
    setReplayKey(replayKey + 1);
  };
  const getHeaderButton = () => {
    if (currentVOD) {
      return {
        customClass: 'close-video-btn',
        icon: 'icon-close',
        customOnClick: player => {
          if (!liveStreamLoaded) {
            if (svs.core.detect.formfactor.mobile()) {
              setPlayerIsLoaded(false);
              handleDropDownAction();
            }
            player === null || player === void 0 || player.destroy();
            setShowPreloadImage(true);
          }
          setVideoEnded(false);
          setCurrentVOD(undefined);
        },
        controlText: 'VideoClose'
      };
    }
    return undefined;
  };
  const getFooterButton = () => {
    if (svs.core.detect.formfactor.mobile()) {
      return {
        icon: 'icon-menu-up',
        customOnClick: () => {
          handleDropDownAction();
        },
        controlText: 'Fold'
      };
    }
    return undefined;
  };
  const toggleFold = (playerVisible, isFolded) => {
    setPlayerIsVisible(playerVisible);
    setFolded(isFolded);
  };
  const handleThumbnailClick = () => {
    handleDropDownAction();
    toggleFold(true, false);
  };
  const renderVideo = () => {
    const VideoPlayerContainer = svs.components.redbee_video_player.VideoPlayerContainer;
    return React.createElement(VideoPlayerContainer, {
      assetId: assetId,
      autoplay: autoplay,
      businessunit: businessunit,
      footerButton: getFooterButton(),
      headerButton: getHeaderButton(),
      headerInfo: getHeaderInfo(),
      key: replayKey,
      noTracking: true,
      onVideoEnded: handleVideoEnded,
      onVideoStarted: handleVideoStarted,
      posterUrl: thumbnail,
      remountPlayer: bumpReplayKey,
      replay: replay,
      sessionToken: sessionToken,
      useLowLatency: useLowLatency
    });
  };
  const noRaceData = () => {
    setNoRaceDataState(!noRaceDataState);
  };
  const renderMobile = options => React.createElement("div", null, noRaceDataState ? React.createElement("div", {
    className: "no-racecards"
  }, React.createElement("i", {
    className: "icon fc-racing icon-600 icon-rest"
  }), React.createElement("span", null, "Just nu finns det inga spelbara lopp. V\xE4lkommen \xE5ter!")) : React.createElement(React.Fragment, null, options.showErrorMessage && React.createElement(StreamPlayerError, {
    buttonHandler: reload,
    handleClick: handleDropDownAction,
    showReloadButton: nrOfReloads === 0
  }), folded && !options.showPlayer && React.createElement(DropDownHeader, {
    folded: folded,
    handleClick: () => toggleFold(true, false),
    handleThumbnailClick: handleThumbnailClick,
    noRaceData: () => noRaceData(),
    setFolded: () => setFolded(),
    thumbnail: thumbnail
  }), !folded && !options.showPlayer && React.createElement(StreamPlayerPreloader, {
    loadPlayer: handleDropDownAction,
    onFold: () => toggleFold(false, true),
    preloadImage: thumbnail
  }), options.showPlayer && React.createElement(React.Fragment, null, React.createElement(DropDownHeader, {
    handleClick: handleDropDownAction
  }), React.createElement("div", {
    className: "player"
  }, empComponentLoaded && renderVideo())), videoEnded && React.createElement(VideoEndedButtons, {
    handleVideoEndedBtnClick: handleVideoEndedBtnClick
  })));


  const renderDesktop = options => {
    if (options.showPreloadImage && thumbnail) {
      return React.createElement(StreamPlayerPreloader, {
        loadPlayer: handleDropDownAction,
        preloadImage: thumbnail
      });
    }
    return React.createElement("div", null, options.showErrorMessage && React.createElement(StreamPlayerError, {
      buttonHandler: reload,
      showReloadButton: nrOfReloads === 0
    }), options.showPlayer && empComponentLoaded && renderVideo(), videoEnded && React.createElement(VideoEndedButtons, {
      handleVideoEndedBtnClick: handleVideoEndedBtnClick
    }));
  };
  const showPlayer = !hasError && assetId && sessionToken && !showPreloadImage;
  const showErrorMessage = playerIsVisible && isLoggedIn && hasError;
  const isSelfService = svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isSelfService') && svs.core.config.data.svsconfig.isSelfService;
  const options = {
    showErrorMessage,
    showPlayer,
    showPreloadImage
  };
  let streamEl;
  if (isSelfService && isStartPage) {
    streamEl = null;
  } else {
    streamEl = React.createElement("div", {
      className: "stream-player ".concat(playerIsVisible ? '' : 'folded ').concat(isStartPage ? 'start-page' : '')
    }, svs.core.detect.formfactor.mobile() ? renderMobile(options) : renderDesktop(options));
  }
  return streamEl;
};
StreamPlayer.defaultPropTypes = {
  isStartPage: false,
  showLive: false
};
svs.racing.streamplayer.StreamPlayer = StreamPlayer;

 })(window);